module.exports = __webpack_public_path__ + "static/media/academy-thumbnail.b8ceb151.png";